// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__pADL4","tab":"Tabs_tab__DIAta","active":"Tabs_active__tySGp"};